import { useTranslation } from 'libs/i18n'
import { useDevice, usePagination } from 'shared/hooks'
import { Table2 } from 'shared/components'
import { Pagination } from 'shared/atoms'
import { getCardTableStyles } from 'styles/table'
import { useColumns } from '../hooks/useColumns'
import { Sale } from 'features/sales'
import type { SaleItem, SalesRes } from 'features/sales/types/sales.types'
import type { Select } from '@table-library/react-table-library/select'
import type { TableNode } from '@table-library/react-table-library/types/table'

type TableSectionProps = {
	sales: SalesRes
	salesLoading: boolean
	select: Select
	onSelectSale: (sale: SaleItem) => void
}

export const TableSection = ({ sales, salesLoading, select, onSelectSale }: TableSectionProps) => {
	const { t } = useTranslation()
	const { isMobileOrTabletHorizontal } = useDevice()
	const columns = useColumns()
	const { handlePagination } = usePagination()

	const results: SaleItem[] = sales.data.results
	const tableStyles = getCardTableStyles(columns)

	return (
		<>
			{isMobileOrTabletHorizontal ? (
				<ul className="divide-y divide-border">
					{results.map((sale) => (
						<Sale key={sale.id} sale={sale} onSelect={onSelectSale} />
					))}
				</ul>
			) : (
				<Table2
					className="mb-0 px-0 py-0 lg:flex lg:min-h-0 lg:flex-1 lg:flex-col"
					columns={columns}
					data={{ nodes: results }}
					isLoading={salesLoading}
					select={select}
					customStyles={tableStyles}
					onRowClick={(node: TableNode) => onSelectSale(node as unknown as SaleItem)}
				/>
			)}
			<div className="flex items-center justify-between gap-3 border-t border-border px-4 py-3 text-[11px] font-medium text-muted-foreground sm:px-5">
				<span>{t('{{ count }} sales', { count: results.length })}</span>
				<Pagination prev={sales.data.previous} next={sales.data.next} onClick={handlePagination} />
			</div>
		</>
	)
}
